//作品
import axios from "axios"
export default {
    getWorksAsync: async (params) => {//获取作品列表
        return axios.get('/get_opus_list', { params: params })
            .then((response) => response)
            .catch((error) => {
                console.log(error);
            });
    },
    signUpAsync: async (data) => {//填写报名信息
        return axios.post('/sign_up_info', data)
            .then((response) => response)
            .catch((error) => {
                console.log(error);
            });
    },
    addWorkAsync: async (data) => {//上传作品
        return axios.post('/add_contest_opus', data)
            .then((response) => response)
            .catch((error) => {
                console.log(error);
            });
    },
    sendTicketAsyncasync: (params) => {//投他一票
        return axios.get('/vote', { params: params })
            .then((response) => response)
            .catch((error) => {
                console.log(error);
            });
    },
    getMyWorksAsync: (params) => {//获取我的作品
        return axios.get('/my_opus', { params: params })
            .then((response) => response)
            .catch((error) => {
                console.log(error);
            });
    },
    getDetailAsync: (params) => {//获取作品详情
        return axios.get('/get_opus_detail', { params: params })
            .then((response) => response)
            .catch((error) => {
                console.log(error);
            });
    },
    getInviteStatus: async (data) => {//获取专家是否可点评
        return axios.post('/query_expert_invite_success', data)
            .then((response) => response)
            .catch((error) => {
                console.log(error);
            });
    },
    getInviteSuccess: async (data) => {//获取专家是否可点评
        return axios.post('/query_expert_invite_success', data)
            .then((response) => response)
            .catch((error) => {
                console.log(error);
            });
    },
    commentOpusAsync: async (data) => {//点评作品
        return axios.post('/comment_opus', data)
            .then((response) => response)
            .catch((error) => {
                console.log(error);
            });
    },
    userdetail:(params) => {//获取作品详情（编辑）
        return axios.get('/get_user_opus_detail', {params:params})
            .then((response) => response)
            .catch((error) => {
                console.log(error);
            });
    },
    updWorkAsync: async (data) => {//修改作品
        return axios.post('/upd_contest_opus', data)
            .then((response) => response)
            .catch((error) => {
                console.log(error);
            });
    },
    revoke: async (data) => {//撤销评分
        return axios.post('/revoke', data)
            .then((response) => response)
            .catch((error) => {
                console.log(error);
            });
    },
    
}
